<div class="assign_expand_container" *ngIf="expanded" [@expandCollapse]>
  <div class="expand_content">
    <!-- <div class="expand_header">
      <h4>{{ expandConfig().title }}</h4>
      <button class="close_button" (click)="collapsePanel()" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </div> -->
    
    <div class="expand_body">
      <div class="assign_section">
        <ng-select
         #assigneeSelect
         [items]="ngSelectItems()"
          bindLabel="name"
          bindValue="_id"
          [ngModel]="selectedUserIds()"
          (ngModelChange)="selectedUserIds.set($event); onUserSelectionChange($event)"
          (add)="onAssigneeAdd()"
          (remove)="onAssigneeRemove()"
          (selectionChanges)="onAssigneeSelectionChanges()"
          (select)="onAssigneeSelect()"
          (change)="onAssigneeChange()"
          [multiple]="true"
          [searchable]="true"
          [clearable]="false"
          [closeOnSelect]="false"
          [virtualScroll]="true"
          [loading]="isLoadingData"
          [placeholder]="isLoadingData ? expandConfig().loadingText : expandConfig().placeholder"
          (search)="onAssigneeSearch($event)"
          (blur)="onAssigneeBlur()"
          (open)="onAssigneeOpen()"
          [ngClass]="{'has-tooltip': selectedUsers().length > 2}"
          [title]="selectedUsers().length > 2 ? selectedUsers().map(getDisplayName).join(', ') : ''"
          [isOpen]="showDropdown()"
          class="assign_select expand-ng-select">
          <ng-template ng-multi-label-tmp let-items="items">
            <!-- <div class="ng-select-selected-items">
              <ng-container *ngFor="let item of items; let i = index">
                <ng-container *ngIf="i < 1">
                  <div class="ng-select-item">
                    <div class="ng-select-item-content">
                      <span class="ng-select-item-name">{{ getDisplayName(item) }}</span>
                    </div>
                    <button 
                      class="ng-select-item-remove" 
                      (click)="removeSelectedUserFromNgSelect(item, $event)" 
                      title="Remove user"
                      type="button">
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.938477 1.02026L7.16113 7.24292" stroke="currentColor" stroke-width="0.541101"/>
                        <path d="M7.16113 1.02026L0.938476 7.24292" stroke="currentColor" stroke-width="0.541101"/>
                      </svg>
                    </button>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="items.length > 1">
                <div class="ng-select-item ng-select-item-more more_assignees">
                  +{{ items.length - 1 }} more
                </div>
              </ng-container>
            </div> -->
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="template-option">
              <div class="user-avatar" [class.has-image]="hasValidImage(item)">
                <img 
                  *ngIf="hasValidImage(item)"
                  [src]="item.image || item.avatar" 
                  [alt]="getDisplayName(item)"
                  (error)="onImageError(item._id)"
                  class="avatar-image" />
                <div 
                  *ngIf="!hasValidImage(item)"
                  class="avatar-placeholder"
                  [style.background-color]="getAvatarColor(item._id)">
                  {{ getInitials(getDisplayName(item)) }}
                </div>
              </div>
              <span class="user-name">{{ getDisplayName(item) }}</span>
            </div>
          </ng-template>
          <ng-template ng-notfound-tmp>
            <div class="no-results">
              <mat-icon>search_off</mat-icon>
              <p>{{ expandConfig().noResultsText }}</p>
            </div>
          </ng-template>
        </ng-select>
      </div>
      
      <div class="assign_selected" *ngIf="selectedUsers().length > 0">
        <label class="assign_label">Selected Assignees ({{ selectedUsers().length }})</label>
        <div class="assign_selected_list">
          <div class="assign_selected_item" *ngFor="let user of selectedUsers(); let i = index">
            <div class="assign_avatar" [class.has-image]="hasValidImage(user)">
              <img 
                *ngIf="hasValidImage(user)"
                [src]="user.image || user.avatar" 
                [alt]="getDisplayName(user)"
                (error)="onImageError(user._id)"
                class="avatar-image" />
              <div 
                *ngIf="!hasValidImage(user)"
                class="avatar-placeholder"
                [style.background-color]="getAvatarColor(user._id)">
                {{ getInitials(getDisplayName(user)) }}
              </div>
            </div>
            <div class="assignee-info">
              <span class="assignee-name">{{ getDisplayName(user) }}</span>
            </div>
            <button class="assign_remove_btn" (click)="removeSelectedUser(i)" title="Remove user" type="button">
             <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
      
      <!-- No Changes Message -->
      <div class="no-changes-message" *ngIf="showNoChangesMessage()">
        <div class="message-content">
          <mat-icon class="message-icon">info</mat-icon>
          <span class="message-text">{{ expandConfig().noChangesMessage }}</span>
        </div>
      </div>
    </div>
    
    <div class="expand_actions">
      <button class="btn-save" (click)="onAssignUsersClick()" [disabled]="selectedUsers().length === 0" type="button">
        {{ expandConfig().confirmText }}
      </button>
      <button class="btn-cancel" (click)="collapsePanel()" type="button">{{ expandConfig().cancelText }}</button>
    </div>
  </div>
</div>

<app-confirm-popup
  [show]="showAssignConfirmPopup()"
  [config]="{
    title: 'Assign Users',
    message: 'Are you sure you want to assign the selected users?',
    type: 'info',
    showCancel: true,
    cancelText: 'Cancel',
    confirmText: 'Assign'
  }"
  (confirm)="confirmAssignUsers()"
  (cancel)="cancelAssignUsers()"
></app-confirm-popup>

